import { persistStore, purgeStoredState } from 'redux-persist';
import bookLocalForage from './localForageProvider';
import {
  appStateFilter,
  documentsFilter,
  roadmapFilter,
} from './persistStateFilter';

let persistor;

const keysToPersist = [
  'appState',
  'categories',
  'documents',
  'news',
  'roadmap',
  'search',
  'securityContext',
];

const config = {
  keyPrefix: 'reduxPersist-',
  storage: bookLocalForage,
  transforms: [
    appStateFilter,
    documentsFilter,
    roadmapFilter,
  ],
  whitelist: keysToPersist,
};

const persistStoreCreator = (store, callback) => {
  persistor = persistStore(store,
    config,
    callback
  );
  return persistor;
};
export default persistStoreCreator;

/**
 * Purges the keys managed by redux-persist and returns a
 * promise with the result.
 *
 * @return {Promise} The promise.
 */
export const purgeAllPersistStore = () => (
  purgeStoredState(config, keysToPersist)
);




// WEBPACK FOOTER //
// ./book/src/commons/offline/persistStoreProvider.js